import React,{useState} from 'react'
import './App.css';
import About from './Components/About';
import Alert from './Components/Alert';
import Navbar from './Components/Navbar';
import TextForm from './Components/TextForm';
/* import { Routes, Route, BrowserRouter as Router } from "react-router-dom"; */

function App() {

  const [mode,setMode] = useState('light');
  const [alert,setAlert]=useState(null);

  const showAlert=(message,type)=>{
    setAlert({
      msg:message,
      type:type
    })
    setTimeout(()=>{
      setAlert(null);
    },1500);
  }
  const toggle = () =>{
    if(mode==='light')
    {
      setMode('dark');
      document.body.style.backgroundColor='#042743';
      showAlert('Dark Mode Enabled','success');
      //document.title='TextUtil - Dark Mode';
      
    }
    else{
      setMode('light');
      document.body.style.backgroundColor='white';
      showAlert('Light Mode Enabled','success');
      //document.title='TextUtil - Light Mode';
      
    }
    
  }
    return (
    <>
    {/* <Router> */}
      <Navbar title="TextUtil" mode={mode} toggleMode={toggle}/>
      <Alert alert={alert}/>
      <div className="container my-4">
        {/* {/* <Routes> */}
         {/*  <Route exact path="/" element={ */}
          <TextForm heading="TextUtil : Word-Character Counter , Case-Converter" 
                             mode={mode} toggleMode={toggle} showAlert={showAlert}/>{/* }/> */}
          {/* <Route exact path="/About" element={ */}
          {/* <About mode={mode}/>{/*  } /> */} 
        {/* </Routes>   */}  
      </div>
    
   {/*  </Router> */}
    </>
  );
}

export default App;
